import React from 'react';
import { Home} from '../constants';
import { useNavigate } from 'react-router-dom';

export const DownTime = () => {
    const navigate = useNavigate();
    const RedirectToLogin = () => {
        navigate('/login');
    }
    return (
        <div style={{position:'fixed', left:0, right:0, top:0, bottom:0, display:'flex', justifyContent:'center', alignItems:'center', flexDirection:'column'}}>
            <div style={{display:'flex', justifyContent:'center', alignItems:'center', flexDirection:'column', width: 445,textAlign: 'center',gap: 18}}>
                <img src={Home} height={228}/>
                <span style={{fontSize:24, fontWeight:'400', display:'block', color:'rgba(0, 0, 0, 0.87'}}>Something Went Wrong</span>
                <span style={{display:'block', fontSize:16, color:'rgba(0, 0, 0, 0.60)', fontWeight:'400',}}>We’re facing a technical issue while signing you in.Please try again in a few minutes.</span>

                 <button className="assign-button" onClick={RedirectToLogin}>Retry Login</button>
            </div>
        </div>
    )
}